import api from './api';

/**
 * Serviço para gerenciamento de pesos de preferências de material
 */
const materialPricingWeightsService = {
  // Listar todos os pesos
  getAllWeights: async (params = {}) => {
    try {
      const response = await api.get('/material-pricing-weights', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar pesos:', error);
      throw error;
    }
  },

  // Buscar peso por ID
  getWeightById: async (id) => {
    try {
      const response = await api.get(`/material-pricing-weights/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar peso:', error);
      throw error;
    }
  },

  // Criar ou atualizar peso
  upsertWeight: async (weightData) => {
    try {
      const method = weightData.id ? 'PUT' : 'POST';
      const url = weightData.id 
        ? `/material-pricing-weights/${weightData.id}`
        : '/material-pricing-weights';
      
      const response = await api[method.toLowerCase()](url, weightData);
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar peso:', error);
      throw error;
    }
  },

  // Deletar peso (desativar)
  deleteWeight: async (id) => {
    try {
      const response = await api.delete(`/material-pricing-weights/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar peso:', error);
      throw error;
    }
  },

  // Calcular peso total baseado nas preferências
  calculateTotalWeight: async (materialPreferences) => {
    try {
      const response = await api.post('/material-pricing-weights/calculate', {
        material_preferences: materialPreferences
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao calcular peso total:', error);
      throw error;
    }
  }
};

export default materialPricingWeightsService;
